"use client";
import { useState } from "react";
import { Fade } from "@mui/material";

import TopBar from "./TopBar";
import Main from "./Main";
import API from "./API";
import Agent from "./Agent";

export default function Client({ modelList }) {
  const [view, setView] = useState(0);
  const views = [Main, Agent, API];

  return (
    <>
      <TopBar view={view} setView={setView} />
      {views.map((View, index) => (
        <Fade key={index} mountOnEnter unmountOnExit in={view === index}>
          <div>
            <View setView={setView} data={modelList} />
          </div>
        </Fade>
      ))}
    </>
  );
}
